import { render, staticRenderFns } from "./ChangeChannel.vue?vue&type=template&id=93054c80&scoped=true"
import script from "./ChangeChannel.vue?vue&type=script&lang=js"
export * from "./ChangeChannel.vue?vue&type=script&lang=js"
import style0 from "./ChangeChannel.vue?vue&type=style&index=0&id=93054c80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93054c80",
  null
  
)

export default component.exports